// @owners { team: patients }
import { COLORS, SPACING } from '@alto/design-library-tokens';
import {
  Button,
  Card,
  Column,
  Description,
  Illustration,
  LgPadding,
  MdPadding,
  MdSpacing,
  Row,
  isFuzeRxBrand,
} from '@alto/design-system';
import React from 'react';
import { Linking } from 'react-native';
import styled from 'styled-components/native';
import { getImage } from '~shared/assets/images/getImage';
import { getImageAltText } from '~shared/assets/images/getImageAltText';
import { getProgynyUnboxingGuideUrl } from '~shared/constants';
import { isNative } from '~shared/helpers/isNative';
import { useAnalytics, usePageViewedEvent } from '~shared/hooks';
import { EVENTS } from '~shared/lib/analytics/src/constants';

const LeftContent = styled(Column)`
  max-width: 70%;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
`;

export const UnboxingGuideCard = () => {
  const { trackEvent } = useAnalytics();

  const onPressUnboxingGuide = () => {
    trackEvent({ event: EVENTS.UNBOXING_GUIDE_TAPPED });
    Linking.openURL(getProgynyUnboxingGuideUrl());
  };

  usePageViewedEvent({
    event: EVENTS.ALTO_EDU_UNBOXING_GUIDE_HOMESCREEN_VIEWED,
  });

  const unboxingCard = (
    <Card
      // FuzeRx has no pink surface: the card sits on primary.050 there (PH-4256).
      style={{
        backgroundColor: isFuzeRxBrand()
          ? COLORS.BACKGROUND_COLORS.PRIMARY_LIGHTER
          : COLORS.BACKGROUND_COLORS.PINK_LIGHT,
      }}
      title="Prepare for your upcoming order"
    >
      <LgPadding topPadding={SPACING.STATIC.MD}>
        <Row spaceBetween>
          <LeftContent spaceBetween>
            <Description>See helpful information, including unboxing and storage guidance</Description>
            <MdSpacing />
            <Button
              type="primary"
              label="See unboxing guide"
              onPress={onPressUnboxingGuide}
              width="inline"
              small
            />
          </LeftContent>
          <Column>
            <Illustration
              source={getImage('unboxingGuide')}
              size="lg"
              accessibilityLabel={getImageAltText('unboxingGuide')}
            />
          </Column>
        </Row>
      </LgPadding>
    </Card>
  );

  return isNative ? (
    <MdPadding
      topPadding={SPACING.STATIC.NONE}
      bottomPadding={SPACING.STATIC.NONE}
    >
      {unboxingCard}
    </MdPadding>
  ) : (
    unboxingCard
  );
};
